import idx from "idx"
import { toLowerCaseIfExists } from "@jsUtils"
/**
 * transform - manipulate data for Meta Data from graphql query
 * @param {object} contentfulProductSpotlight - meta data content from page query
 * @returns {object}
 */
// function transform(contentfulPageMeta, page, locationData) {
function transform(contentfulProductSpotlight) {
  const title = idx(contentfulProductSpotlight, _ => _.title)
  const theme = toLowerCaseIfExists(idx(contentfulProductSpotlight, _ => _.theme))
  const colorRaw = toLowerCaseIfExists(idx(contentfulProductSpotlight, _ => _.color))
  const color = colorRaw === "purple" ? "works" : colorRaw
  const eyebrow = idx(contentfulProductSpotlight, _ => _.eyebrow)
  const headline = idx(contentfulProductSpotlight, _ => _.headline)
  const layoutName = idx(contentfulProductSpotlight, _ => _.layout)
  const ctaLink = idx(contentfulProductSpotlight, _ => _.ctaLink)
  const ctaLabel = idx(contentfulProductSpotlight, _ => _.ctaLabel)
  const image = idx(contentfulProductSpotlight, _ => _.image)
  const description = idx(contentfulProductSpotlight, _ => _.description.description)

  let layout = "right"
  switch (layoutName) {
    case "Text Left Product Center":
      layout = "left"
      break
    case "Text Left Product Full":
      layout = "center"
      break
    default:
      layout = "right"
  }

  return {
    title,
    theme,
    color,
    eyebrow,
    headline,
    layout,
    ctaLink,
    ctaLabel,
    image,
    description
  }
}

export default { transform }
